import { gql } from '__generated__';

export default gql(`
  query GetParticipantFieldImports($project_id: ID!, $page: Int, $per_page: Int) {
    project(id: $project_id) {
      id
      events {
        total
      }
      participant_field_imports(page: $page, per_page: $per_page) {
        data {
          id
          filename
          event {
            id
            title
          }
          field {
            id
            title
            scope
            type
          }
          length
          errors_count
          ready_to_import
          validated_at
          importing
          imported_at
          confirmation_mail_sending
          created_at
          deletable
        }
        current_page
        last_page
        per_page
        total
      }
    }
  }
`);
